import React from 'react';
import { isChunkLoadError, reloadForStaleChunk } from '../utils/chunkLoadRecovery';

class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      return null;
    }
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) {
      reloadForStaleChunk();
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }

    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;
